import AssociationSetupPassword from './AssociationSetupPassword.page';

export default AssociationSetupPassword;
